import * as React from "react";
import {
  FeedItemComment,
  FeedItemCommentOnGenericEntry,
  FeedItemCommentForum,
} from "../../../server/feed/buildfeed";
import {
  FeedElementContainer,
  ActionPanel,
} from "../DesignSystem/formatting/FeedComponents";
import { LinkToUser } from "../DesignSystem/LinkToUser";
import { RLink } from "../DesignSystem/RLink";
import { FormattedText } from "../DesignSystem/FormattedText";
import { DateWithTooltip } from "../DesignSystem/DateWithTooltip";

export const FeedElementComment = ({
  item,
}: {
  item: FeedItemComment | FeedItemCommentOnGenericEntry | FeedItemCommentForum;
}) => {
  const commenting_username =
    item.type === "comment-forum"
      ? item.commentor.username
      : item.commenting_username;
  const commenting_avatar_url =
    item.type === "comment-forum" ? item.commentor.avatar_url : item.avatar_url;

  const title = item.type === "comment-forum" ? item.topic.title : item.title;
  const link =
    item.type === "comment-forum"
      ? `/forum/topic/${item.topic.id}`
      : `/entry/${item.entry_id}`;

  return (
    <FeedElementContainer
      href={link}
      title={
        <>
          <LinkToUser linkUser={{ username: commenting_username }} />
          <span className="text-slate-500 dark:text-slate-400">
            {" "}commented on{item.type === "comment-forum" ? " the forum post" : ""}{" "}
          </span>
          <RLink white to={link}>{title}</RLink>
        </>
      }
      avatars={[
        { username: commenting_username, avatar_url: commenting_avatar_url },
      ]}
      icon={"comment"}
      subtitle={<DateWithTooltip date={new Date(item.created)} />}
      bottom={
        <ActionPanel
          like={{ count: item.comment.likes }}
          reply={{ url: link }}
        />
      }
    >
      <FormattedText text={item.comment.content} />
    </FeedElementContainer>
  );
};
